import CheckIcon from "@mui/icons-material/Check";
import BookingSlots from "../../searchFlowVersionB/components/bookingSlots/BookingSlots.jsx";
import i18n from "../../../utils/i18n";
import classes from "./regSuccessScreen.module.scss";

const RegSuccessScreen = () => (
  <div className={classes.root}>
    <div className={classes.scrollArea}>
      <div className={classes.content}>
        <div className={classes.mainColumn}>
          <section className={classes.hero}>
            <div className={classes.checkIcon} aria-hidden="true">
              <CheckIcon />
            </div>
            <h1 className={classes.title}>{i18n.t("searchflow.successtitle")}</h1>
            <p className={classes.subtitle}>
              {i18n.t("searchflow.successsubtitle")}
            </p>
          </section>

          <section className={classes.bookingSection} aria-label={i18n.t("general.bookingappointment")}>
            <BookingSlots />
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default RegSuccessScreen;
